/**
 * The "shopper data" a `PprHole` waits for (COM-482, see ppr-hole.tsx).
 *
 * A promise carrying the `status` React's `use()` reads synchronously: a
 * fulfilled one never suspends (no streamed boundary, no `<template>`), a
 * pending one suspends until it settles — and the prerender's never does.
 * Kept out of ppr-hole.tsx so that module exports components only.
 */
/**
 * Set on `self` by the shell prelude, before any client module evaluates, so
 * the client renders the holes as boundaries only when the document has them.
 */
export const PPR_DOCUMENT_FLAG = "__HEC_PPR_DOCUMENT";

type ShopperDataBase = Promise<void> & {
  /** Names of the holes that suspended on this promise (prerender only). */
  holes: Set<string>;
};

export type ShopperData =
  | (ShopperDataBase & { status: "fulfilled"; value: void })
  | (ShopperDataBase & { status: "pending" });

/** Shopper data is available: holes render inline. The default everywhere. */
export const SHOPPER_DATA_READY: ShopperData = Object.assign(
  Promise.resolve(),
  { status: "fulfilled" as const, value: undefined, holes: new Set<string>() },
);

/** Shopper data that never arrives: every hole stays suspended (shell prerender). */
export function pendingShopperData(): ShopperData {
  return Object.assign(new Promise<void>(() => {}), {
    status: "pending" as const,
    holes: new Set<string>(),
  });
}
